import { useEffect } from "react";
import { useMap } from "react-map-gl";
import { useMapboxDraw } from "../DrawToolProvider";
import { useDispatch } from "react-redux";
import { inputsActions, canopyActions } from "../..";

const HandleFeatureClick = ({ feature }) => {
  const dispatch = useDispatch();
  const { current: mapRef } = useMap();
  const map = mapRef.getMap();
  const draw = useMapboxDraw();

  useEffect(() => {
    if (!map || !draw) return;
    // console.log("the feature:", feature);
    map.on("click", handleClick);

    return () => {
      map.off("click", handleClick);
    };
  }, [map]);

  const handleClick = (e) => {
    const featureIds = draw.getFeatureIdsAt(e.point);
    const clicked_feature = featureIds.length > 0 ? draw.get(featureIds[0]) : null;
    if (clicked_feature) {
      // If a feature is clicked, update the selectedFeatureId in Redux
      if (clicked_feature.properties.index === feature.properties.index && clicked_feature.properties.shape == "siteFeature") {
        dispatch(inputsActions.update_site_input("selectedFeatureId", clicked_feature.properties.index));
      } else if (clicked_feature.properties.shape == "tree" || clicked_feature.properties.shape == "building" || clicked_feature.properties.shape == "treeLine") {
        dispatch(canopyActions.updateCanopyInputs("selected_shade_object_id", clicked_feature.id));
      }
    } else {
      // If no feature is clicked, update selectedFeatureId to undefined in Redux
      dispatch(inputsActions.update_site_input("selectedFeatureId", undefined));
    }
  };

  return null;
};

export { HandleFeatureClick };
